export default {
  en: {
    MANAGE_NUMBER_POOLS: 'Manage Pools',
    NUMBER_POOLS_POOL_SIZE: 'Pool Size',
    IMPRESSIONS_DAY: 'Impressions per Day',
    MISSES_DAY: 'Misses per Day',
    IMPRESSIONS_MONTH: 'Impressions per Month',
    MISSES_MONTH: 'Misses per Month',
    NUMBER: 'number | numbers',
    NUMBER_ORDER_CONFIRMATION_MODAL_MESSAGE:
      'Are you sure you want to generate a purchase order for {orderAmount} numbers?',
    NUMBERS_TAGS_TT:
      'Tags associated with a number. Tags will be attached to every call to the number',
    NUMBERS_TAGS: 'Tags',
    NUMBERS_NAME_TT:
      'Name of the number. Used to quickly identify numbers on the portal and for reporting purposes',
    NUMBERS_NAME: 'Name',
    NUMBERS_NUMBER: 'Number',
    NUMBERS_FORMATTED: 'Formatted',
    NUMBERS_ALLOCATION_DT: 'Allocated',
    NUMBERS_CHARGE_DT: 'Renews',
    NUMBERS_LINK_CAMPAIGN: 'Campaign',
    NUMBERS_LINK_POOL: 'Number Pool',
    NUMBERS_LINK_PUBLISHER: 'Publisher',
    NUMBERS_COUNTRY: 'Country',

    NO_ORDERS_FOUND: 'Could not find orders for the selected time range.',
    NUMBER_ASSIGN_PUBLISHER: 'Assign Publisher',
    NUMBER_ASSIGN_PUBLISHER_DEFAULT: 'Optional',
    NUMBER_ASSIGN_PUBLISHER_SELECT: 'Select Publisher',
    NUMBER_ASSIGN_PUBLISHER_TT:
      'By selecting a publisher, Ringba will assign your new phone number to their account allowing you to specifically track their performance.',
    NUMBER_CHARGE_ACCOUNT: 'Bill Card',
    NUMBER_CHARGE_ACCOUNT_TT:
      'If your account balance is not enough to complete this allocation, we will bill your default credit card instead.',
    NUMBER_CONTAINS: 'Contains',
    NUMBER_CONTAINS_DEFAULT: 'Optional',
    NUMBER_CONTAINS_TT:
      'Have Ringba search for available phone numbers that contain specific digits. Example: Entering \'222\' into this field will make sure Ringba only selects phone numbers that contain \'222\'.',
    NUMBER_COUNTRY: 'Country',
    NUMBER_COUNTRY_DEFAULT: 'Select country',
    NUMBER_COUNTRY_TT:
      'Select the country you would like to purchase a phone number in.',
    NUMBER_CREATE_BUTTON: 'Create Number',
    NUMBER_CREATE_NUMBER_TT:
      'Creating a number adds it to your account and allows you to use the number to track the performance of a campaign or publisher.',
    NUMBER_CREATE_SUCCESS: 'Number created.',
    NUMBER_MULTIPLE_NUMBERS: 'Amount',
    NUMBER_MULTIPLE_NUMBERS_TT:
      'Amount of numbers you want to purchase. Selecting more than 1 will generate a purchase order that will buy the numbers in batches.',
    NUMBER_SELECT_AFFILIATE: 'Select Publisher',
    NUMBER_REMOVE_AFFILIATE: 'Remove Publisher',
    NUMBER_REMOVE_AFFILIATE_TEXT: 'Are you sure you want to remove the publisher from this number?',
    NUMBER_REMOVE_AFFILIATE_CONFIRM: 'Remove',
    NUMBER_ORDER: 'Number Order',
    NUMBER_ORDERS: 'Number Orders',
    NUMBER_ORDER_CONFIRMATION_MODAL_CONFIRM_ACTION: 'Allocate Numbers',
    NUMBER_ORDER_CONFIRMATION_MODAL_TITLE: 'Confirm Number Allocation Order',
    NUMBER_ORDER_CREATE_SUCCESS: 'Number order created.',
    ORDER: 'Order',
    ORDERS_LOADING: 'Loading Orders',
    ORDERS_PENDING_AMOUNT: '({amount} <i class="fa fa-clock-o fa-fw"></i>)',
    ORDERS_TIMEFRAME_ALL_TIME: 'All Time',
    ORDERS_TIMEFRAME_MONTH: 'Last 30 Days',
    ORDERS_TIMEFRAME_WEEK: 'Last 7 Days',
    ORDER_ALLOCATED: 'Allocated: ',
    ORDER_AMOUNT: 'Amount: ',
    ORDER_AREA_CODE: 'Area Code: ',
    ORDER_STATUS: 'Status: ',
    ORDER_COUNTRY: 'Country: ',
    ORDER_NUMBER_TYPE: 'Type: ',
    ORDER_PUBLISHER: 'Publisher: ',
    ORDER_CHARGE: 'Bill Card: ',
    ORDER_ERROR_MESSAGE: 'Error Message: ',
    ORDER_CANCEL: 'Cancel Order',
    ORDER_ITEM_TITLE:
      '{completed}/{requested} {countryCode} {numberType} {areaCode} Numbers',
    ORDER_LOADING: 'Loading Order',
    NUMBER_POOL_NUMBER_TYPE: 'Number Type',
    NUMBER_POOL_NUMBER_TYPE_TT:
      'Choose the number type <br/><br/> TollFree: Only use Toll Free numbers. Notice: Toll Free numbers have higher per-minute charges than local phone numbers <br/><br/> Local: Only use Local numbers ',
    INPUT_LABEL_PREFIX_TT:
      'Only purchase phone numbers with this specific prefix. Example: Entering \'212\' into this field will make sure Ringba only selects phone numbers with the prefix \'212\'.',
    INPUT_LABEL_PREFIX: 'Prefix',
    INPUT_LABEL_PUBLISHER: 'Assign Publisher',
    INPUT_LABEL_PUBLISHER_TT:
      'By selecting a publisher, Ringba will assign your new phone number to their account allowing you to specifically track their performance.',
    INPUT_LABEL_NUMBER_TYPE: 'Number Type',
    INPUT_LABEL_NUMBER_TYPE_TT:
      'Choose the number type <br/><br/> TollFree: Only use Toll Free numbers. Notice: Toll Free numbers have higher per-minute charges than local phone numbers <br/><br/> Local: Only use Local numbers ',
    NUMBER_POOL_SHOW_ALL: 'Show All Number Pools',
    NUMBER_POOL_ALLOCATION_DEFAULT: '0',
    NUMBER_POOL_ALLOCATION_EDIT_TT:
      'How many numbers would you like to add to your number pool?',
    NUMBER_POOL_ALLOCATION_EDIT: 'Add Numbers',
    NUMBER_POOL_ALLOCATION_TT:
      'How many numbers would you like to keep in your number pool?',
    NUMBER_POOL_ALLOCATION: 'Pool Size',
    NUMBER_POOL_AREA_CODE_DEFAULT: 'Optional',
    NUMBER_POOL_AREA_CODE_TT:
      'Entering \'212\' will make Ringba only select phone numbers with the prefix \'212\'.',
    NUMBER_POOL_AREA_CODE: 'Prefix',
    NUMBER_POOL_ASSIGN_PUBLISHER_DEFAULT: 'Select Publisher',
    NUMBER_POOL_ASSIGN_PUBLISHER_TT:
      'Allow a publisher to use this Number Pool\'s resources.',
    NUMBER_POOL_ASSIGN_PUBLISHER: 'Assign Publisher',
    NUMBER_POOL_CANCEL: 'Cancel',
    NUMBER_POOL_CHARGE_ACCOUNT_TT:
      'If your account balance is not enough to complete this allocation, we will bill your default credit card instead.',
    NUMBER_POOL_CHARGE_ACCOUNT: 'Recharge Card',
    NUMBER_POOL_CONFIRM_ALLOCATION_RECHARGE_TEXT:
      'Use billing credit card if balance is not sufficient to allocate {countNumbers} {numberText}',
    NUMBER_POOL_CONFIRM_ALLOCATION_SUBMIT_BUTTON: 'Allocate',
    NUMBER_POOL_CONFIRM_ALLOCATION_TITLE: 'Confirm Number Pool resize',
    NUMBER_POOL_CONFIRM_CANCEL_BUTTON: 'Cancel',
    NUMBER_POOL_CONFIRM_DEALLOCATION_KEEP_NUMBERS_TEXT:
      'Keep numbers released from this number pool',
    NUMBER_POOL_CONFIRM_DEALLOCATION_SUBMIT_BUTTON: 'Deallocate',
    NUMBER_POOL_CONFIRM_DEALLOCATION_TITLE: 'Confirm Number Pool resize',
    NUMBER_POOL_CONTAINS_BUTTON: 'See Numbers',
    NUMBER_POOL_CONTAINS: 'Contains',
    NUMBER_POOL_COUNTRY_DEFAULT: 'Enter country',
    NUMBER_POOL_COUNTRY_TT:
      'Select the country you would like to purchase phone numbers in.',
    NUMBER_POOL_COUNTRY: 'Country',
    NUMBER_POOL_CREATE_BUTTON: 'Create Number Pool',
    NUMBER_POOL_CREATE_NUMBER_BUTTON: 'Create Number',
    NUMBER_POOL_CREATE_POOL_TT: '',
    NUMBER_POOL_CREATE_SUCCESS: 'Number pool created.',
    NUMBER_POOL_CURRENT_COUNTS_TT: 'Current Free Numbers in this Number Pool.',
    NUMBER_POOL_CURRENT_COUNTS: 'Free',
    NUMBER_POOL_HEADER: 'Create Number Pool',
    NUMBER_POOL_LOCAL: 'Local',
    NUMBER_POOL_LOCK_FLAG_MIN: 'Minutes',
    NUMBER_POOL_LOCK_FLAG_SEC: 'Seconds',
    NUMBER_POOL_LOCK_TT:
      'The length of time Ringba locks a number to a user after they close their browser. Example: 60 Seconds locks the number for 1 Minute.',
    NUMBER_POOL_LOCK: 'Closed Browser Delay',
    NUMBER_POOL_MAX_FLAG_MIN: 'Minutes',
    NUMBER_POOL_MAX_FLAG_SEC: 'Seconds',
    NUMBER_POOL_MAX_LOCK_TT:
      'The length of time Ringba locks a number to a user if they leave their browser open. Example: 300 Seconds locks the number for 5 Minutes.',
    NUMBER_POOL_MAX_LOCK: 'Idle Limit',
    NUMBER_POOL_NAME_DEFAULT: 'California Local Numbers',
    NUMBER_POOL_NAME_TT:
      'Your number pool name will be used to display information around the Ringba portal. Short number pool names work best.',
    NUMBER_POOL_NAME: 'Name',
    NUMBER_POOL_NUMBERS_ALLOCATED_SUCCESS:
      'We have scheduled {numberCount} {NUMBER} to be added to your number pool {poolName}.',
    NUMBER_POOL_NUMBERS_DEALLOCATED_SUCCESS:
      'Removed {numberCount} {NUMBER} from {poolName}.',
    NUMBER_POOL_PAGE_TITLE: 'Create Pool',
    NUMBER_POOL_POOL_COUNT_TT: 'Current count of numbers assigned to this pool',
    NUMBER_POOL_POOL_COUNT: 'Current Allocation',
    NUMBER_POOL_SAVE_ALLOCATE: 'Save and Allocate',
    NUMBER_POOL_SAVE_BUTTON: 'Save',
    NUMBER_POOL_STARTS_WITH_DEFAULT: 'Optional',
    NUMBER_POOL_STARTS_WITH_TT:
      'Entering \'222\' into this field will make Ringba only select phone numbers starting with \'222\' after the country code.',
    NUMBER_POOL_STARTS_WITH: 'Starts With',
    NUMBER_POOL_TOLL_FREE_TT:
      'Only use Toll Free numbers. Notice: Toll Free numbers have higher per-minute charges than local phone numbers.',
    NUMBER_POOL_TOLL_FREE: 'Toll Free',
    NUMBER_POOL_UPDATE_SUCCESS: 'Number pool updated.',
    NUMBER_POOLS_ACTIONS_DELETE: 'Delete Pool',
    NUMBER_POOLS_ACTIONS_EDIT: 'Edit',
    NUMBER_POOLS_ACTIONS: 'Actions',
    NUMBER_POOLS_ALLOCATED: 'In Use',
    NUMBER_POOLS_ASSIGN_TT: 'Assign this number to a publisher.',
    NUMBER_POOLS_ATTACH_PUBLISHER_SUCCESS: 'Publisher assigned.',
    NUMBER_POOLS_AVAILABLE: 'Free',
    NUMBER_POOLS_COUNTRY: 'Country',
    NUMBER_POOLS_CREATE_NEW_NUMBER_POOL: 'Create Number Pool',
    NUMBER_POOLS_EXPORT_BUTTON_CSV: 'Export CSV',
    NUMBER_POOLS_EXPORT_ICON_CSV_ALT: 'Export to CSV.',
    NUMBER_POOLS_EXPORT_ICON_XLS_ALT: 'Export to XLS.',
    NUMBER_POOLS_HEADER_LOADING: 'Loading Number Pools.',
    NUMBER_POOL_HEADER_LOADING: 'Loading Number Pool Details.',
    NUMBER_POOLS_HEADER_NONE: 'You do not have any Number Pools.',
    NUMBER_POOLS_HEADER: 'Number Pools',
    NUMBER_POOLS_LINK_PUBLISHER: 'Publisher',
    NUMBER_POOLS_LOCK: 'Closed Browser Delay',
    NUMBER_POOLS_MAX_LOCK: 'Browser Idle Limit',
    NUMBER_POOLS_NAME: 'Name',
    NUMBER_POOLS_NUMBER_POOLS_TT:
      'Use pools of numbers to track the source data from your users. Google Ads keywords, organic traffic, and Facebook ads are great examples of traffic sources you can optimize with number pooling.',
    NUMBER_POOLS_NUMBERS_ALLOCATING: 'Allocating',
    NUMBER_POOLS_RESTRICTED_COUNTRY_MESSAGE: 'Contact Ringba Support to add numbers from this country. &nbsp;&nbsp;<a href="https://support.ringba.com/en-us/article/number-pools-7wumsp/" class="text-underline" target="_blank">Learn more</a>',
    NUMBER_POOLS_LIMIT_WARNING: 'You can add a maximum of 500 numbers at a time.',
    NUMBER_POOLS_ALLOCATING_MESSAGE: 'Numbers are currently being allocated. You can add more numbers when it is complete.',
    DELETE_NUMBER_POOL_MODAL_TITLE: 'Delete Number Pool',
    DELETE_NUMBER_POOL_MODAL_NUMBER_POOL_NONE_ASSOCIATION_TEXT: 'The number pool is not associated with any campaign, number or publisher',
    DELETE_NUMBER_POOL_MODAL_CANCEL_ACTION: 'Cancel',
    DELETE_NUMBER_POOL_MODAL_CONFIRM_ACTION: 'Delete',
    DELETE_NUMBER_POOL_CONFIRM_DEALLOCATION_KEEP_NUMBERS_TEXT: 'Keep numbers in this pool for future use',
    CHECK_NUMBER_POOL_REFERENCES: 'Determining if this number pool is currently associated with any campaigns, numbers or publishers',
    DELETE_NUMBER_POOL_MODAL_NUMBER_POOL_ASSOCIATION_TEXT: 'Are you sure you want to delete this number pool? {numberPoolName} is currently associated with the following items:',
    DELETE_NUMBER_POOL_SUCCESSFUL_MESSAGE: 'Number Pool successfully deleted',
    VIEW_CAMPAIGN: "View Campaign",
    MENU_LEFT_NUMBERS_VIEW: 'Manage Numbers',
    NUMBERS_HEADER_LOADING: 'Loading Numbers.',
    NUMBER_HEADER_LOADING: 'Loading Number Details.',
    NUMBERS_ACTIONS: 'Actions',
    NUMBERS_HEADER_NONE: 'You have not created any Numbers.',
    UNASSIGN_PUBLISHER_FROM_NUMBER: 'Unassign Number',
    NUMBERS_LINK_POOL_TT: 'This number is already in use and not available to be added to a number pool.',
    NUMBERS_LINK_CAMPAIGN_TT: 'This number is not linked to a campaign.',
    NUMBERS_ASSIGN_TT: 'Assign this number to a publisher.',
    ENABLED_TEXT: 'Enabled',
    INTERNAL_USE_NUMBER: 'Internal Number',

    NUMBERS_SHOW_ALL: 'Show All Numbers',

    NUMBERS_FILTER_ALL: 'All',
    NUMBERS_FILTER_NO_CAMPAIGN: 'No Campaign',
    NUMBERS_FILTER_UNASSIGNED: 'Unassigned',
    NUMBERS_FILTER_NO_PUBLISHER: 'No Publisher',
    NUMBERS_FILTER_NOT_IN_POOL: 'Not in Number Pool',
    NUMBERS_FILTER_IN_POOL: 'In Number Pool',

    NUMBERS_ASSIGN_NP_TT: 'Assign this number to a number pool.',
    NUMBERS_ACTIONS_EDIT: 'Edit Number',
    NUMBERS_ACTIONS_ENABLE: 'Enable Number',
    NUMBERS_ACTIONS_PAUSE: 'Pause Number',
    NUMBERS_DEALLOCATE: 'Deallocate Number',

    PAUSE_NUMBER_MODAL_TITLE: 'Confirm Pause Number',
    PAUSE_NUMBER_MODAL_TEXT: 'Are you sure you want to stop the calls coming on <strong>{phone}</strong> number?',
    NUMBER_ENABLE_SUCCESS: 'Number has been enabled successfully',
    NUMBER_PAUSE_SUCCESS: 'Number has been paused successfully',

    DELETE_NUMBER_MODAL_TITLE: 'Confirm Deallocate Number',
    DELETE_NUMBER_MODAL_NUMBER_CHECK_ASSOCIATION_TEXT: 'Determining if this number is currently associated with any <strong class=\'f-s-13\'>campaigns, publishers or pools.</strong>',
    DELETE_NUMBER_MODAL_NUMBER_CHECK_ASSOCIATION_ERROR_TEXT: 'An error occurred while determining associated campaigns, pools or publishers, please try again',
    DELETE_NUMBER_MODAL_NUMBER_NONE_ASSOCIATION_TEXT: 'The number is not associated with any campaign, publisher or pool',
    DELETE_NUMBER_MODAL_NUMBER_ASSOCIATION_TEXT: 'Are you sure you want to deallocate this number?</br><strong>{phoneNumber}</strong> is currently associated with the following items:',
    DELETE_NUMBER_MODAL_VIEW_PUBLISHER: 'View Publisher',
    DELETE_NUMBER_MODAL_VIEW_NUMBER_POOL: 'View Number Pool',
    DELETE_NUMBER_SUCCESSFUL_MESSAGE: 'Number successfully deallocated',

    DELETE_NUMBER_MODAL_CANCEL_ACTION: 'Cancel',
    DELETE_NUMBER_MODAL_CONFIRM_ACTION: 'Deallocate',

    NUMBER_SELECT_NUMBER_POOL_ADD_NUMBER_POOL: 'Add',
    NUMBER_SELECT_NUMBER_POOL_NUMBER_LABEL: 'Number',
    NUMBER_SELECT_NUMBER_POOL_LABEL: 'Number Pool',
    NUMBER_SELECT_NUMBER_POOL_ADD_SUCCESSFUL: 'Number Pool added successfully.',
    NUMBER_SELECT_NUMBER_POOL_SEARCH: 'Search Number Pool',
    NUMBER_SELECT_NUMBER_POOL: 'Select Number Pool',

    NUMBER_SELECT_AFFILIATE_NUMBER: 'Number',
    NUMBER_SELECT_AFFILIATE_PUBLISHER: 'Publisher',
    NUMBER_SELECT_AFFILIATE_REMOVE_PUBLISHER_SUCCESSFUL: 'Publisher removed successfully.',
    NUMBER_SELECT_AFFILIATE_SEARCH_PUBLISHER: 'Search Publisher',
    NUMBER_SELECT_AFFILIATE_ADD_PUBLISHER: 'Add',
    NUMBERS_OFFER: 'Offer',
    NUMBERS_CONTACT_SUPPORT_MESSAGE: 'Contact Ringba Support to add numbers from other countries.'
  }
};
